export default __webpack_public_path__ + "static/media/Gloves of the Silent Slayer.b365ecdf.jpg";